import React from 'react';
// import { useNavigate } from 'react-router';
// import { useTranslation } from 'react-i18next';

// import { useAuth } from '../../../hooks/useAuth';
// import { CHALLENGE_NAMES } from '../../../helpers/enums';
// import { getRoute, ROUTE_ENUMS } from '../../../helpers/routes';
import MfaForm from './forms/MfaForm';

import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import VideoBackground from '../../../components/VideoBackground';

const MFA = () => {
	// const { t } = useTranslation('mfa');
	// const { authStep, isAuthenticated } = useAuth();
	// const navigate = useNavigate();

	// useEffect(() => {
	// 	console.log('MFA Page', { authStep, isAuthenticated });

	// 	if (authStep === null && isAuthenticated) {
	// 		navigate(getRoute(ROUTE_ENUMS.DASHBOARD), { replace: true });
	// 	}

	// 	if (authStep === null && !isAuthenticated) {
	// 		navigate(getRoute(ROUTE_ENUMS.LOGIN), { replace: true });
	// 	}
	// }, [authStep, isAuthenticated]);

	return (
		<Stack flex={1} justifyContent="center">
			<VideoBackground>
				<Stack
					alignItems="center"
					justifyContent="center"
					margin={8}
					gap={3}
					flex={1}
				>
					<Paper
						sx={{
							border: '1px solid rgba(0,0,0,0.20)',
							backgroundColor: 'rgba(255, 255, 255, 0.1)',
							backdropFilter: 'blur(16px)'
						}}
						elevation={0}
					>
						<Stack padding={6} gap={2}>
							<Stack marginBottom={1}>
								<Typography variant="h4" color="glass.main">
									Multi-Factor Login
								</Typography>
								<Typography variant="caption" color="glass.main" align="center">
									Please enter your verification code displayed <br /> in your
									authenticator app.
								</Typography>
							</Stack>
							<MfaForm />
						</Stack>
					</Paper>
				</Stack>
			</VideoBackground>
		</Stack>
	);
};

MFA.propTypes = {};

export default MFA;
